import React, { Component } from "react";
import { Row, Col, Container, Progress } from "reactstrap";
import numeral from "numeral";
import { inyectionTrinidad } from "../../../redux/actions/SpiderActions";
import { connect } from "react-redux";
import Rut from "rutjs";

class Summary extends Component {
  constructor(props) {
    super(props);
    const search = window.location.search;
    var step1 = JSON.parse(localStorage.getItem("step1"));
    var arrFechaCurse = step1 ? step1.fechaCurse.split("-") : '';
    var arrFechaVencimiento = step1 ? step1.fechaVencimiento.split("-") : '';

    this.state = {
      search: search,
      loadingCalculo: false,
      calculateFeeRequest: JSON.parse(localStorage.getItem("calculateFeeRequest")),
      step1: JSON.parse(localStorage.getItem("step1")),
      step2: JSON.parse(localStorage.getItem("step2")),
      fechaCurse:
        arrFechaCurse[2] + "-" + arrFechaCurse[1] + "-" + arrFechaCurse[0],
      fechaVencimiento:
        arrFechaVencimiento[2] +
        "-" +
        arrFechaVencimiento[1] +
        "-" +
        arrFechaVencimiento[0],
    };
  }

  goToBack = () => {
    this.props.history.push("/page/userdata" + this.state.search);
  };

  sendData = () => {

    var renta = 0;
    renta = this.state.step2.monthlyIncome.replace("$", "");
    renta = renta.split(".").join("");
    renta = parseInt(renta);

    var rut = new Rut(this.state.step2.rut);
    rut = rut.getNiceRut(false);

    this.setState({ loadingCalculo: true });

    var montoVFMG = 0;
    var data = {};

    var triniReq = {
      ...this.state.calculateFeeRequest,
      TrinidadSolicitudRestSpiderReq: {
        Concesionario: parseInt(this.state.step1.dataCes.CONFIGURACION.codCes),
        Sucursal: this.state.step1.dataCes.CONFIGURACION.codSucursal,
        //id externo
        CodigoExterno: this.state.step1.idExterno ? this.state.step1.idExterno : '',
        Topic: `SIM_${rut}`,
        TipoNegocio: parseInt(this.state.step1.dataProducto.CodTipoNegocio),
        TipoNegocioDescription: this.state.step1.dataProducto.DesTipoNegocio,
        Producto: parseInt(this.state.step1.productoSelected.CodProducto),
        ProductoDescription: this.state.step1.productoSelected.DesProducto,
        Marca: (this.state.step1.isHomologated && this.state.step1.homologatedBrand.homologatedBrandName) ? this.state.step1.homologatedBrand.homologatedBrandName : this.state.calculateFeeRequest.ConsultaCuotaReqRest.Marca,
        Modelo: (this.state.step1.isHomologated && this.state.step1.homologatedModel.homologatedModelName) ? this.state.step1.homologatedModel.homologatedModelName : this.state.calculateFeeRequest.ConsultaCuotaReqRest.Modelo,
        Anio: parseInt(this.state.step1.year),
        Precio_vehiculo: parseInt(this.state.step1.priceClean),
        EstadoVehiculo: this.state.step1.vehicleStatus === "1" ? "N" : "U",
        Pie: parseInt(this.state.step1.footClean),
        Plazo: parseInt(this.state.step1.term),
        Canal: `${this.state.step1.dataCes?.CONFIGURACION?.codCanal || 31}`,
        Vendedor: this.state.step1.dataCes.CONFIGURACION.codVendedor,
        Seguros: { ...this.state.step1.insurances },
        DATOS_CLIENTE: {
          Rut: rut,
          Tipo_cliente: parseInt(this.state.step2.employmentSituation),
          Tipo_cliente_Descripcion: this.state.step2.employmentSituationDescription,
          Nombre: this.state.step2.name,
          Apellido_Paterno: this.state.step2.lastName,
          Apellido_Materno: this.state.step2.motherLastName,
          Email: this.state.step2.email,
          Telefono: this.state.step2.phone.replace("+56", ""),
          Nacionalidad: this.state.step2.nationality,
          Nacionalidad_Descripcion: this.state.step2.nationalityDescription,
          Direccion: this.state.step2.address,
        },
        DATOS_LABORALES: {
          Tipo_Contrato: parseInt(this.state.step2.typeContract),
          Tipo_Contrato_Descripcion: this.state.step2.typeContractDescription,
          Tipo_Renta: parseInt(this.state.step2.typeRent),
          Tipo_Renta_Descripcion: this.state.step2.typeRentDescription,
          Renta: parseInt(renta),
          Antiguedad: parseInt(this.state.step2.laborOld),
        },
      },
    };
    // Campo Campaña
    if(this.state.step1.cmp) {
        triniReq.TrinidadSolicitudRestSpiderReq.cmp = this.state.step1.cmp;
    }
    // Campo vehicleType
    if(this.state.step1.vehicleType) {
      triniReq.TrinidadSolicitudRestSpiderReq.vehicleType = this.state.step1.vehicleType;
    }
    if (this.state.step1.dataProducto.CodTipoNegocio === 1) {
      montoVFMG = this.state.calculateFeeRequest.ConsultaCuotaReqRest.MontoVFMG;
      data = {
        TrinidadSolicitudRestSpiderReq: {
          ...triniReq.TrinidadSolicitudRestSpiderReq,
          MontoVFMG: Math.round(montoVFMG)
        },
      };
    } else {
      data = triniReq;
    }

    console.log('inyection Trinidad', data);

    this.props.inyectionTrinidad(data, (res) => {
      res.success && localStorage.clear();
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.trinidad !== this.props.trinidad) {
      if (this.props.trinidad) {
        // console.log("this.props.trinidad", this.props.trinidad);
        this.setState({ loadingCalculo: false });
        if (
          this.props.trinidad.return &&
          this.props.trinidad.return.code === "200"
        ) {
          this.props.history.push("/page/success" + this.state.search);
          localStorage.clear();
        } else {
          this.props.history.push("/page/error" + this.state.search, { state: this.props.trinidad.return.message});
          localStorage.clear();
        }
      }
    }
  }

  render() {
    return (
      <Container>
        {this.state.loadingCalculo &&
          <div className="sm-progress-bar">
            <Progress
              value={parseInt(this.props.socketRes?.Percent || 0)}
              animated
            />
            <div className="sm-progress-text">Estamos generando tu solicitud</div>
          </div>
        }
        <Row>
          <Col md={8} className="offset-md-2 ">
            <div className="card-shadow   p-4">
              <Row>
                <Col>
                  <div>
                    <div className="title-page">Resumen</div>
                    <div className="line-h1 mb-4"></div>
                    <div className="sub-title-page mb-4">
                      Datos de la solicitud
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col md={4}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Producto</label>
                    <div className="div-resumen">
                      {this.state.step1.dataProducto.DesTipoNegocio}
                    </div>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Marca</label>
                    <div className="div-resumen">

                      {(this.state.step1.isHomologated && this.state.step1.homologatedCarsList.length > 0) ?
                        (<section>{this.state.step1.homologatedBrand.homologatedBrandName}</section>)

                        :
                        (this.state.step1.listMarcas
                          .filter((marca) => marca.VemCodigoMarca + "" === this.state.step1.brand)
                          .map((marca, index) => (<section key={index}>{marca.VeMNombre}</section>)))
                      }
                    </div>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Modelo</label>
                    <div className="div-resumen">
                      {this.state.step1.isHomologated ?
                        (<section>{this.state.step1.homologatedModel.homologatedModelName}</section>)
                        :
                        this.state.step1.listModelos
                          .filter((modelo) => modelo.VMoCodigoModelo + "" === this.state.step1.model)
                          .map((modelo, index) => (<section key={index}>{modelo.VMoModelo}</section>))}
                    </div>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Año</label>
                    <div className="div-resumen">{this.state.step1.year}</div>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Estado</label>
                    <div className="div-resumen">
                      {this.state.step1.vehicleStatus === "1"
                        ? "Nuevo"
                        : "Usado"}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Precio Vehículo
                    </label>
                    <div className="div-resumen">
                      {" "}
                      {"$" +
                        numeral(this.state.step1.priceClean)
                          .format("0,0[,]0")
                          .replace(/,/g, ".")}
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Pie</label>
                    <div className="div-resumen">
                      {"$" +
                        numeral(this.state.step1.footClean)
                          .format("0,0[,]0")
                          .replace(/,/g, ".")}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Fecha de curse
                    </label>
                    <div className="div-resumen">{this.state.fechaCurse}</div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Fecha primer vencimiento
                    </label>
                    <div className="div-resumen">
                      {this.state.fechaVencimiento}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Plazo</label>
                    <div className="div-resumen">{this.state.step1.term}</div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Valor Cuota*</label>
                    <div className="div-resumen">
                      {"$" +
                        numeral(this.state.step1.shareValue)
                          .format("0,0[,]0")
                          .replace(/,/g, ".")}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">CAE</label>
                    <div className="div-resumen">
                      {this.state.step1.valorCae} %
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <div className="sub-title-page">Datos personales</div>
                </Col>
              </Row>

              <Row className="mt-4">
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Nombre</label>
                    <div className="div-resumen">
                      {this.state.step2.name} {this.state.step2.lastName}{" "}
                      {this.state.step2.motherLastName}
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Rut</label>
                    <div className="div-resumen">{this.state.step2.rut}</div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Email</label>
                    <div className="div-resumen">{this.state.step2.email}</div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Teléfono</label>
                    <div className="div-resumen">{this.state.step2.phone}</div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Nacionalidad</label>

                    {this.state.step2.nationality &&
                      this.state.step2.nationality === "1" && (
                        <div className="div-resumen">Chileno(a)</div>
                      )}
                    {this.state.step2.nationality &&
                      this.state.step2.nationality === "2" && (
                        <div className="div-resumen">Extranjero(a)</div>
                      )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">Direccion</label>
                    <div className="div-resumen">
                      {this.state.step2.address}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Ingresos mensuales
                    </label>
                    <div className="div-resumen">
                      {this.state.step2.monthlyIncome}
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Situación Laboral
                    </label>

                    {this.state.step2.employmentSituation &&
                      this.state.step2.employmentSituation === "1" && (
                        <div className="div-resumen">Dependiente</div>
                      )}
                    {this.state.step2.employmentSituation &&
                      this.state.step2.employmentSituation === "2" && (
                        <div className="div-resumen">Independiente</div>
                      )}
                    {/* {this.state.step2.employmentSituation &&
                      this.state.step2.employmentSituation === "3" && (
                        <div className="div-resumen">Empresa</div>
                      )} */}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Tipo de contrato
                    </label>

                    {this.state.step2.typeContract &&
                      this.state.step2.typeContract === "1" && (
                        <div className="div-resumen">Indefinido</div>
                      )}
                    {this.state.step2.typeContract &&
                      this.state.step2.typeContract === "2" && (
                        <div className="div-resumen">A plazo</div>
                      )}
                    {this.state.step2.typeContract &&
                      this.state.step2.typeContract === "3" && (
                        <div className="div-resumen">A contrata</div>
                      )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Tipo de renta
                    </label>

                    {this.state.step2.typeRent &&
                      this.state.step2.typeRent === "1" && (
                        <div className="div-resumen">Fija</div>
                      )}
                    {this.state.step2.typeRent &&
                      this.state.step2.typeRent === "2" && (
                        <div className="div-resumen">Variable</div>
                      )}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="labe-simulation-home">
                      Antigüedad laboral
                    </label>
                    <div className="div-resumen">
                      {this.state.step2.laborOld} meses
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <div className="text-center w-100">
                  <button
                    onClick={this.goToBack}
                    type="button"
                    className="btn button-back mt-4 mr-4"
                    disabled={this.state.loadingCalculo}
                  >
                    Volver
                  </button>

                  <button
                    onClick={this.sendData}
                    type="button"
                    className="btn button-send mt-4"
                    disabled={this.state.loadingCalculo}
                  >
                    Enviar Solicitud
                  </button>
                </div>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  trinidad: state.spider.trinidad,
});

const mapDispatchToProps = {
  inyectionTrinidad,
};
export default connect(mapStateToProps, mapDispatchToProps)(Summary);
